import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Fall Home Maintenance Tips' },
	{
		name: 'description',
		content: 'What every homeowner should do to prepare for winter.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">
				Extreme Maintenance: Home Edition - Fall
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				As the weather gets cooler and the leaves begin to fall, you should
				start to get your home ready for winter. In New York, the likelihood of
				experiencing extreme winter snow and ice is high. These harsh conditions
				can cause damage to yourself and your property, so it is a great idea to
				do all you can to prevent such damage. The following is a list of
				preventative measures you may take in the Fall to prepare for Winter
				weather.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Clean gutters from fallen leaves and debris to ensure that gutters can
				function properly. While at it, check downspouts to verify that any
				water is directed to a safe location. Water left to accumulate around
				the foundation can cause extreme hydrostatic pressure and cause moisture
				to penetrate into the basement.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Consider installing an ice damming prevention system that will reduce
				the likelihood of damage caused by ice damming.
			</p>
		</>
	)
}
